export enum ConversationMessageType {
    WhatsappTemplateSent = 'whatsapp_template_sent',
    UnsupportedReceived = 'unsupported_received',
    UnsupportedSent = 'unsupported_sent',
    WhatsappInteractiveSent = 'whatsapp_interactive_sent',
    WhatsappInteractiveReplyReceived = 'whatsapp_interactive_reply_received',
    SmsSent = 'sms_sent',
    SmsReceived = 'sms_received',
    WhatsappBasicSent = 'whatsapp_basic_sent',
    WhatsappBasicReceived = 'whatsapp_basic_received',
    EmailReceived = 'email_received',
    EmailSent = 'email_sent',
    Note = 'note',
    AiReceived = 'ai_received',
    AiSent = 'ai_sent',
    AIWhatsappTemplateReceived = 'ai_whatsapp_template_received',
    WebChatSent = 'web_chat_sent',
    WebChatReceived = 'web_chat_received',
}

export const UNSUPPORTED_MESSAGE_TYPES = [
    ConversationMessageType.UnsupportedReceived,
    ConversationMessageType.UnsupportedSent,
];
